import { useMutation } from "urql";

import { UpdateCreditUnderwritingDocument } from "../../../graphql/generated.ts";

export function useUpdateCreditUnderwriting() {
  return useMutation(UpdateCreditUnderwritingDocument);
}
